import { useMemo } from "react";
import "./ErrorComponent.css";
import { useNavigate } from "react-router-dom";

const ErrorComponent = ({
  missingLink,
  pageNotFound,
  pageNotFound1,
  missingLinkWidth,
  loremParaAlignSelf,
  loremParaWidth,
  pageNotFoundPadding,
  pageNotFoundTextAlign,
}) => {
  const frameDivStyle = useMemo(() => {
    return {
      width: missingLinkWidth,
    };
  }, [missingLinkWidth]);

  const missingLinkStyle = useMemo(() => {
    return {
      alignSelf: loremParaAlignSelf,
      width: loremParaWidth,
    };
  }, [loremParaAlignSelf, loremParaWidth]);

  const loremParaStyle = useMemo(() => {
    return {
      padding: pageNotFoundPadding,
    };
  }, [pageNotFoundPadding]);

  const pageNotFoundStyle = useMemo(() => {
    return {
      textAlign: pageNotFoundTextAlign,
    };
  }, [pageNotFoundTextAlign]);
  const navigate = useNavigate();

  return (
    <div className="frame-parent-error">
      <div className="frame-group">
        <div className="missing-link-parent" style={frameDivStyle}>
          <b className="missing-link" style={missingLinkStyle}>
            {missingLink}
          </b>
          <div className="lorem-para" style={loremParaStyle}>
            <h1 className="page-not-found" style={pageNotFoundStyle}>
              {pageNotFound}
            </h1>
          </div>
        </div>
        <h3 className="page-not-found1">{pageNotFound1}</h3>
      </div>
      <button
        className="back-to-home-wrapper"
        onClick={() => {
          navigate("/");
        }}
      >
        <div className="back-to-home">Back to home</div>
      </button>
    </div>
  );
};

export default ErrorComponent;
